var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"box":"","multiple":"","items":_vm.weekdays,"label":_vm.$t('schedule.days'),"rules":_vm.rules,"clearable":""},model:{value:(_vm.selectedDays),callback:function ($$v) {_vm.selectedDays=$$v},expression:"selectedDays"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c54105f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/schedule/WeekdaySelector.vue
// module id = null
// module chunks = 